module.exports = __webpack_public_path__ + "img/x6.c2a34bfb.png";